import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PagingParams } from 'mbs-ui-shared@models';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';
import { BackupHistoryState, backupHistoryAdapter } from './state';

const selectBackupHistoryFeatureSelector = createFeatureSelector<BackupHistoryState>(StoreTypes.BackupHistory);

const { selectEntities: selectEntitiesByAdapter } = backupHistoryAdapter.getSelectors();
const selectEntities = createSelector(selectBackupHistoryFeatureSelector, selectEntitiesByAdapter);

export const selectById = (id: string) => createSelector(selectEntities, (entities) => entities[id]);

export const selectPagingLoading = createSelector(selectBackupHistoryFeatureSelector, (state) => state.paging.loading);
export const selectPagingLoaded = createSelector(selectBackupHistoryFeatureSelector, (state) => state.paging.loaded);
export const selectPagingPageNumbers = createSelector(selectBackupHistoryFeatureSelector, (state) =>
  Object.keys(state.paging.pages).map((v) => parseInt(v, 10))
);
export const selectPagingCurrentPageNumber = createSelector(selectBackupHistoryFeatureSelector, (state) => state.paging.currentPageNumber);
export const selectPagingPerPage = createSelector(selectBackupHistoryFeatureSelector, (state) => state.paging.perPage);
export const selectPagingTotal = createSelector(selectBackupHistoryFeatureSelector, (state) => state.paging.total);
export const selectPagingParams = createSelector(
  selectPagingPerPage,
  selectPagingCurrentPageNumber,
  (perPage, currentPageNumber) => ({ perPage, currentPageNumber } as PagingParams)
);
export const selectPagingFilters = createSelector(selectBackupHistoryFeatureSelector, (state) => state.paging.filters);
export const selectPreQueryPagingParams = createSelector(
  selectPagingFilters,
  selectPagingParams,
  selectPagingPageNumbers,
  (filters, pagingParams, pageNumbers) => ({ filters, pagingParams, pageNumbers })
);

export const selectCurrentPage = createSelector(
  selectBackupHistoryFeatureSelector,
  selectPagingCurrentPageNumber,
  selectEntities,
  (state, currentPage, entities) => ((currentPage && state.paging.pages[currentPage]) || []).map((id) => entities[id])
);

export const selectTotalComputers = createSelector(selectBackupHistoryFeatureSelector, (state) => state.totalComputers);
export const selectShowLatestPlanResult = createSelector(selectBackupHistoryFeatureSelector, (state) => state.showLatestPlanResult);
